import { CompensationPreview } from "@/components/compensation-preview-card";

import { SkeletonTicket } from "../../components/ui/skeletons/ticket-skeleton";
import { useReadItems } from "@/lib/compensations/read";
import { isFinalStatus } from "@/lib/compensations/types";

export default function Compensations() {
  const { data } = useReadItems();

  if (data?.length === 0) {
    return (
      <section className="px-4 py-8 md:px-6 md:py-12 overflow-scroll w-full">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          <p>Brak aktywnych zgłoszeń.</p>
        </div>
      </section>
    );
  }

  return (
    <section className="px-4 py-8 md:px-6 md:py-12 overflow-scroll w-full">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {data?.length
          ? data
              .filter(isFinalStatus)
              .map((c) => <CompensationPreview key={c.id} compensation={c} />)
          : Array(8)
              .fill(0)
              .map((_item, i) => <SkeletonTicket key={i} />)}
      </div>
    </section>
  );
}
